var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal-light-large"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 32,
    height: 21.3333,
    rx: 4,
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "paypal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.5642 16.88L13.7976 15.4133H13.2776H10.8242L12.5309 4.57333C12.5354 4.53975 12.552 4.50895 12.5776 4.48666C12.6044 4.46595 12.637 4.45428 12.6709 4.45333H16.8109C18.1909 4.45333 19.1376 4.74 19.6376 5.30666C19.8588 5.54435 20.0129 5.83653 20.0842 6.15333C20.162 6.53833 20.162 6.935 20.0842 7.32V7.65333L20.3176 7.78666C20.4952 7.8752 20.6555 7.99487 20.7909 8.14C20.9947 8.386 21.1262 8.6837 21.1709 9C21.2208 9.41348 21.2028 9.83234 21.1176 10.24C21.0296 10.7352 20.8559 11.2112 20.6042 11.6467C20.4008 11.9958 20.1259 12.2979 19.7976 12.5333C19.4671 12.7587 19.0991 12.9235 18.7109 13.02C18.2751 13.1299 17.827 13.1837 17.3776 13.18H17.0509C16.8219 13.18 16.6002 13.2602 16.4242 13.4067C16.2473 13.5557 16.1311 13.7644 16.0976 13.9933V14.1267L15.6909 16.7133V16.8133C15.6957 16.8308 15.6957 16.8492 15.6909 16.8667H15.6509L13.5642 16.88Z",
    fill: "#253D80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M20.5361 7.38667L20.4961 7.63333C19.9494 10.4333 18.0761 11.4067 15.6894 11.4067H14.4761C14.1842 11.4063 13.9354 11.6184 13.8894 11.9067L13.2694 15.8533L13.0894 16.9733C13.0759 17.063 13.1019 17.1542 13.1608 17.2232C13.2196 17.2922 13.3054 17.3324 13.3961 17.3333H15.5561C15.8122 17.3331 16.03 17.1464 16.0694 16.8933V16.7867L16.4761 14.2067V14.0667C16.5125 13.8146 16.7281 13.6274 16.9828 13.6267H17.3361C19.4228 13.6267 21.0628 12.78 21.5361 10.2933C21.7922 9.44343 21.6342 8.52258 21.1094 7.80667C20.9429 7.63588 20.7492 7.49394 20.5361 7.38667V7.38667Z",
    fill: "#189BD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M19.9603 7.16L19.7069 7.09333L19.4269 7.04C19.0739 6.98721 18.7172 6.96268 18.3603 6.96666H15.1069C15.0309 6.96458 14.9555 6.98057 14.8869 7.01333C14.7323 7.0857 14.6246 7.23105 14.6003 7.4L13.9336 11.78V11.9067C13.9795 11.6184 14.2283 11.4063 14.5203 11.4067H15.7336C18.1203 11.4067 19.9936 10.4333 20.5403 7.63333L20.5803 7.38666C20.4367 7.31246 20.2873 7.25003 20.1336 7.2L19.9603 7.16Z",
    fill: "#242E65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M14.6022 7.4C14.6265 7.23105 14.7343 7.08571 14.8889 7.01333C14.9575 6.98058 15.0329 6.96458 15.1089 6.96667H18.3622C18.7191 6.96269 19.0758 6.98721 19.4289 7.04L19.7089 7.09333L19.9622 7.16L20.0889 7.2C20.2426 7.25003 20.3919 7.31246 20.5355 7.38667C20.7522 6.55375 20.5536 5.66745 20.0022 5.00667C19.3355 4.3 18.2422 4 16.8155 4H12.6689C12.3769 3.99965 12.1281 4.2117 12.0822 4.5L10.3555 15.44C10.3401 15.5432 10.3701 15.648 10.4379 15.7273C10.5057 15.8066 10.6046 15.8526 10.7089 15.8533H13.2689L13.9355 11.78L14.6022 7.4Z",
    fill: "#253D80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.2ba5ee8285161107a39600edac50f6ab.svg";
export { ForwardRef as ReactComponent };